import { useState, useEffect, useCallback } from "react";
import { Spinner } from "react-bootstrap";
import CodecModal from "./codecsModal";
import useApi from "../../../hooks/apiService";
import CodecTabela from "./codecsTable";
import NoDataTables from "../../../components/noDataTables";

function Codecs() {
  const { fetchData, deleteData, updateData, postData } = useApi();
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");
  const [mappingId, setMappingId] = useState(null);
  const [history, setHistory] = useState([]);
  const [input, setInput] = useState([]);
  const [strategy, setStrategy] = useState([]);
  const [codecs, setCodecs] = useState([]);
  const [tableUpdated, setTableUpdated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleClose = useCallback(() => {
    setShowModal(false);
    setError("");
    setMappingId(null);
    setHistory([]);
  }, []);

  const handleShow = useCallback(() => {
    setShowModal(true);
    setMappingId(null);
  }, []);

  const handleDataAdded = useCallback(() => {
    setTableUpdated((prev) => !prev);
  }, []);

  const handleDataDeleted = useCallback(() => {
    setTableUpdated((prev) => !prev);
  }, []);

  const handleDataEdited = useCallback(() => {
    setTableUpdated((prev) => !prev); // Toggle to trigger re-fetching
    // Optionally, you can add logic here to preserve the active accordion state if needed
  }, []);

  useEffect(() => {
    const handleData = async () => {
      try {
        const response = await fetchData("codecs");
        if (response && response.data) {
          const sortedMapping = response.data.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          setCodecs(sortedMapping);
        } else {
          console.error("Resposta inesperada da API:", response);
        }
      } catch (error) {
        console.error("Erro ao buscar os dados:", error);
      } finally {
        setIsLoading(false);
      }
    };
    handleData();
  }, [tableUpdated]);

  useEffect(() => {
    fetchData("/decoding-strategies")
      .then((response) => {
        const sortedstrategys = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );

        setStrategy(sortedstrategys);
      })
      .catch((error) => {
        console.error("Erro ao buscar os dados da API:", error);
      });

    fetchData("/inputs")
      .then((response) => {
        const sortedInputs = response.data
          .map((input) => ({ id: input.id, name: input.name }))
          .sort((a, b) => a.name.localeCompare(b.name));

        setInput(sortedInputs);
      })
      .catch((error) => {
        console.error("Erro ao buscar os dados da API:", error);
      });
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="text-center p-5">
          <Spinner animation="border" />
        </div>
      ) : codecs.length > 0 ? (
        <CodecTabela
          onDataAdded={handleDataAdded}
          onDataDeleted={handleDataDeleted}
          onDataEdited={handleDataEdited}
          input={input}
          strategy={strategy}
          codecs={codecs}
          onShowModal={handleShow}
          tableUpdated={tableUpdated}
          setTableUpdated={setTableUpdated}
          deleteData={deleteData}
          updateData={updateData}
          postData={postData}
          setShowModal={setShowModal}
          fetchData={fetchData}
        />
      ) : (
        <NoDataTables message="Nenhum codec cadastrado" addItem={handleShow} />
      )}

      {showModal && (
        <CodecModal
          show={showModal}
          handleClose={handleClose}
          handleShow={handleShow}
          error={error}
          setError={setError}
          mappingId={mappingId}
          setMappingId={setMappingId}
          history={history}
          setHistory={setHistory}
          input={input}
          strategy={strategy}
          setCodecs={setCodecs}
          codecs={codecs}
          handleDataAdded={handleDataAdded}
          postData={postData}
        />
      )}
    </>
  );
}

export default Codecs;
